export function bootTool(selector: string, mount: (root: HTMLElement) => void): void {
	const run = (): void => {
		document.querySelectorAll<HTMLElement>(selector).forEach((node) => {
			if (node.dataset.kbMounted === '1') {
				return;
			}
			node.dataset.kbMounted = '1';
			mount(node);
		});
	};
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', run);
	} else {
		run();
	}
}
